export class VoterListConfig {
  limit?: number;
  offset?: number;
  type?: string;
}
